import { ReactElement } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { TitleLayout } from '@/components/layout'
import { CompanyLinks } from '@/components/layouts/Company/CompanyLinks'
import { Head } from '@/components/layouts/Head'

const sectionTitle = {
  titleText: 'Top Message',
  subTitleText: 'トップメッセージ',
}

export const TopMessagePage = () => {
  return (
    <>
      <Head
        title={sectionTitle.subTitleText}
        description="トライアルホールディングスの会長 永田久男 からのメッセージをご覧いただけます。"
        ogp={{ type: 'article', url: 'company/topmessage/' }}
      />
      <TopMessageContainer>
        <TopMessageTitle style={{ marginBottom: '70px' }}>
          <SectionTitle
            color="normal"
            titleText={sectionTitle.titleText}
            subTitleText={sectionTitle.subTitleText}
          />
        </TopMessageTitle>
        <div><img src="/images/Sign_Hiro_Nagata_JP.png" style={{ width: '100%' }} alt="永田　洋幸" /></div>
        <TopMessageText style={{ marginTop: '70px' }}>
          {/* <h3>リテールDXを通じて世の中を豊かな社会へ</h3> */}
          <p>
            1974年、トライアルの前身である「あさひ屋」が設立されました。1984年にトライアルカンパニーに商号変更し、それより「ITで流通を変える」をビジョンに、私たちは挑戦を続けております。
          </p>
          <p>
            当時、アメリカのウォルマートを視察し、ITを駆使してスーパーセンターというフォーマットで急成長している姿を目の当たりにします。流通情報革命によって、人々が「豊かさ」を享受している姿に感銘を受け、その可能性に大きな刺激を受けました。
          </p>
          <p>
            日本でも流通情報革命を起こし、人々の生活をより豊かに、より快適にすることで、身近にあるしあわせを提供できる社会を作りたい。その「思いの丈」が私たちの原動力なのです。
          </p>
          <p>
            現在、トライアルグループは「テクノロジーと、人の経験知で、世界のリアルコマースを変える。」というビジョンを掲げ、挑戦を続けております。
          </p>
          <p>
            私の使命は、この「思いの丈」を、従業員一人一人の力によって、永続的な成長を可能にする「仕組み」へと昇華させることです。次の100年を見据えた強固な経営基盤を築き、ビジョナリーカンパニーへと進化してまいります。
          </p>
          <p>
            その道程は決して平坦なものではありません。しかし、理屈や常識を超えた情熱に、多くの従業員やお取引先が共感し、そしてお客さまに支えていただけているからこそ、今日のトライアルグループがあります。
          </p>
          <p>
            遠い未来に向けて仲間と集い、果敢に挑戦し続ける。その精神こそが、「トライアル（TRIAL）」という社名に込められた私たちの原点です。
          </p>
          <p>
            私たちの挑戦の先にあるもの。それは、お客さまの豊かな暮らしです。変革の成果を「より良い品質を、より安く」という形でお客さまに還元し、テクノロジーを駆使することで、これまでにない利便性と新たなお買い物体験を創出してまいります。
          </p>
          <p>
            トライアルグループ従業員一同、すべてのお客さまのために、そして日本の流通をさらによくするために、これからも邁進いたします。
          </p>
          <RightSign>
            <p>
              株式会社トライアルホールディングス
              <br />
              代表取締役社長
            </p>
            <h4>永田 洋幸</h4>
          </RightSign>
        </TopMessageText>
        <CompanyLinks padding={{ pc: '180px 0 0' }} />
      </TopMessageContainer>
    </>
  )
}

TopMessagePage.getLayout = function getLayout(page: ReactElement) {
  const pageTitle = {
    title: 'Corporate Information',
    subTitle: '企業情報',
  }

  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '企業情報', path: '/company/' },
    { name: 'トップメッセージ', path: '' },
  ]

  return (
    <TitleLayout {...pageTitle} breadCrumbs={breadCrumbs} isRequiredBackground>
      {page}
    </TitleLayout>
  )
}

const TopMessageContainer = styled.div`
  width: 1040px;
  padding-bottom: 130px;
  padding-top: 83px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 35px;
  }
`
const TopMessageTitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 140px;
  row-gap: 69px;

  @media screen and (max-width: 1047px) {
    margin-bottom: 58px;
    row-gap: 36px;
  }
`
const TopMessageText = styled.div`
  width: 100%;
  font-size: 18px;
  color: ${theme.colors.textTitle};
  text-align: left;
  letter-spacing: 0.36px;
  line-height: 32px;
  margin-top: 140px;

  h3 {
    font-size: 28px;
    letter-spacing: 1.68px;
    font-weight: bold;
    color: ${theme.colors.trialBlue};
    margin-bottom: 44px;
  }

  p {
    margin-bottom: 2em;
  }

  @media screen and (max-width: 1047px) {
    font-size: 15px;
    letter-spacing: 0.6px;
    line-height: 25px;
    margin-top: 58px;
    margin-bottom: 0px;

    h3 {
      max-width: 225px;
      font-size: 20px;
      letter-spacing: 2px;
      line-height: 30px;
      margin-bottom: 30px;
    }
  }
`
const RightSign = styled.div`
  text-align: right;
  line-height: 30px;
  margin-top: 68px;

  h4 {
    margin-top: 24px;
    font-size: 25px;
  }

  @media screen and (max-width: 1047px) {
    letter-spacing: 0.3px;
    margin-top: 46px;

    h4 {
      margin-top: 20px;
      font-size: 24px;
      letter-spacing: 0.48px;
    }
  }
`
